import { escapeHtml } from "@medplum/core";

import { getCurrentYear } from "../utils/getCurrentYear";

interface FormNotificationProps {
  clientName: string;
  organizationName: string;
  encounterLink: string;
}

const encounterNoteTemplate = ({
  clientName,
  organizationName,
  encounterLink,
}: FormNotificationProps) => {
  const sanitizedClientName = escapeHtml(clientName);

  return `
      <html dir="ltr" lang="en">
        <head>
          <meta charSet="UTF-8" />
          <title>QuiltedEHR Email</title>
        </head>
        <body>
          <div style="border-radius: 8px; width: 480px; margin: 0 auto; background: #fff; padding: 0 0 24px 0; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);">

            <div style="font-size: 18px; font-weight: bold; margin: 32px 0 0 40px;">
              Hi ${sanitizedClientName},
            </div>
            <div style="font-size: 16px; margin: 12px 0 0 40px; margin-bottom: 24px;">
              There has been an update to one of your encounters at <strong>${organizationName}</strong>.
            </div>
            <div style="margin: 0 0 0 40px;">
              <a
                href="${encounterLink}"
                style="background: #552831; border-radius: 32px; padding: 12px 40px; text-decoration: none; font-size: 16px; font-weight: bold; display: inline-block; margin-top: 16px; margin-bottom: 24px; border: none; color: #fff;"
              >
                View Encounter
              </a>
            </div>
          </div>
          <div style="background: #552831; text-align: center; font-size: 14px; padding: 24px 0 8px 0; margin-top: 32px; color: #fff;">
            © ${getCurrentYear()} Quilted Health. All rights reserved.
            <div style="font-size: 14px; margin: 8px 0 0 0;">
              <a
                href="https://www.quiltedhealth.com/privacy-policy"
                style="text-decoration: underline; margin: 0 8px; color: #fff;"
              >
                Privacy policy
              </a>
              •
              <a
                href="https://www.quiltedhealth.com/terms-of-service"
                style="text-decoration: underline; margin: 0 8px; color: #fff;"
              >
                Terms of service
              </a>
            </div>
          </div>
        </body>
      </html>
    `;
};

export default encounterNoteTemplate;
